// import 'intl-tel-input/build/css/intlTelInput.min.css';

import "./utils";


import './swiper'
import './popup'
import './accordeon'
import './accordeonFunctions'
import './events/click'
import './events/load'
import './events/properties'
import './events/resize'
import './events/popup'
import './events/getPage'
import './events/timer'
import './events/intersect'


import './apartments/sceletonElement'
import './apartments/getNewCarts'
import './apartments/event'
import './apartments/apartments'
import './apartments/logic'
import './apartments/tags' 
import './range'
import './mask'
import './form'
import "./showMore"
import './page'
import "./files"
import "./pixel"
import "./scrollToTop"

 import './gsap/home'



import './home/gallery'


import "../css/main.scss";